import axiosInstance from '../../api/axios';
import type { PersonaKey } from '../../components/analytics/widgetRegistry.tsx';

// Mirrors skeptics-backend's `DashboardLayout` shape verbatim (Feature 5.3,
// wave 13a — `/api/dashboards/:key/layout`). Do not rename fields without
// updating both sides of the contract. `:key` is one of the 5 persona keys
// (`controller|cae|cfo|tester|auditor`), validated server-side.
export type WidgetInstance = {
  instance_id: string;
  widget_key: string;
  x: number;
  y: number;
  w: number;
  h: number;
  config?: Record<string, unknown>;
};

export type DashboardLayoutResponse = {
  layout: WidgetInstance[];
  is_default: boolean;
};

const BASE = '/api/dashboards';

export const fetchDashboardLayout = async (key: PersonaKey): Promise<DashboardLayoutResponse> => {
  const response = await axiosInstance.get<DashboardLayoutResponse>(`${BASE}/${encodeURIComponent(key)}/layout`);
  return {
    layout: response?.data?.layout ?? [],
    is_default: response?.data?.is_default ?? true,
  };
};

export const saveDashboardLayout = async (
  key: PersonaKey,
  layout: WidgetInstance[]
): Promise<DashboardLayoutResponse> => {
  const response = await axiosInstance.put<DashboardLayoutResponse>(`${BASE}/${encodeURIComponent(key)}/layout`, {
    layout,
  });
  return {
    layout: response?.data?.layout ?? layout,
    is_default: response?.data?.is_default ?? false,
  };
};

export const resetDashboardLayout = async (key: PersonaKey): Promise<DashboardLayoutResponse> => {
  const response = await axiosInstance.delete<DashboardLayoutResponse>(`${BASE}/${encodeURIComponent(key)}/layout`);
  return {
    layout: response?.data?.layout ?? [],
    is_default: response?.data?.is_default ?? true,
  };
};
